import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-consulta-desvalorizacao-media',
  templateUrl: './consulta-desvalorizacao-media.component.html',
  styleUrls: ['./consulta-desvalorizacao-media.component.scss']
})
export class ConsultaDesvalorizacaoMediaComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';

  @Input() token = '';

  constructor() { }

  ngOnInit() { }

  ngOnChanges() {
    if( this.consulta.lista.length > 0 ){
      this.statusMsg = "OBS: A PRIMEIRA LINHA PERCENTUAL É REFERENTE AO ANO ANTERIOR, A SEGUNDA É REFERENTE À DESVALORIZAÇÃO TOTAL";
      this.status = 'info';
    }else{
      this.statusMsg = "NADA CONSTA";
      this.status = 'info';
    }
  }
}
